import { createSelector } from 'reselect';
import { standortUrlSelector } from '../url';
import _ from 'lodash';
import { pendingResponse } from '../../fetchStatus';
import { extraParamsSelector } from '../util';

export const standortByUrlSelector = state => {
    const standort = state.standort;
    const standortUrl = standortUrlSelector(state);
    return standort?.[standortUrl];
};

export const wheelDetailSelector = createSelector([standortByUrlSelector], standortByUrl => {
    return standortByUrl?.wheelDetail;
});

const wheelIdSelector = createSelector([extraParamsSelector], params => {
    const { wheelId } = params;
    if (_.isNil(wheelId) || !_.isString(wheelId) || _.isEmpty(wheelId)) {
        throw new Error(`Expected valid productUrl, instead got: ${wheelId}`);
    }
    return wheelId;
});

export const wheelDetailResponseSelector = createSelector([wheelDetailSelector, wheelIdSelector], (urlAndWheelDetail, wheelId) => {
    const wheelIdSelectorResponse = urlAndWheelDetail?.[wheelId];
    return wheelIdSelectorResponse ?? pendingResponse;
});
